<template>
	<div class="container">
		<h1 class="titulo texto-centrado-escritorio m-y-2 m-y-3-md">Créditos</h1>
		<div class="flex-container">
			<div class="flex-col">
				<h2 class="lista-titulo">Instituciones y organizaciones</h2>
				<div class="lista-elementos m-b-3">
					<!-- <div class="elemento">
						<img class="foto" src="@/assets/img/instituciones/conacyt.png" alt="">
						<p class="nombre">Consejo Nacional de Ciencia y Tecnología</p>
					</div> -->
					<div class="elemento">
						<img class="foto" src="@/assets/img/instituciones/geociencias.png" alt="">
						<p class="nombre">Centro de Geociencias UNAM</p>
					</div>
					<div class="elemento">
						<img class="foto" src="@/assets/img/instituciones/iies.png" alt="">
						<p class="nombre">Instituto de Investigaciones en Ecosistemas y Sustentabilidad UNAM</p>
					</div>
				</div>
			</div>
			<div class="flex-col">
				<h2 class="lista-titulo">Investigadores</h2>
				<div class="lista-elementos m-b-2">
					<router-link class="elemento enlace-investigadorxs" v-for="investigadorx in investigadorxs"
						v-bind:key="investigadorx.id"
						:to="{
							path: `/creditos/${investigadorx.id}`,
							props: {
								info_investigador: JSON.stringify(investigadorx)
							}
						}"
						>
						<img class="foto foto-redondeada" :src="require(`@/assets/img/investigadores/${investigadorx.foto}`)" alt="">
						<div class="info-invest" :to="`/${investigadorx.id}`">
							<p class="nombre">{{investigadorx.apellido_paterno}} {{investigadorx.apellido_materno}}, {{investigadorx.nombre}}</p>
							<p class="cargo">{{investigadorx.cargo}}</p>
							<p class="institucion">{{investigadorx.institucion}}</p>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import investigadorxs from '@/assets/data/creditos.json';

export default {
	name: 'Creditos',
	data(){
		return {
			investigadorxs: investigadorxs,
		}
	}
}

</script>

<style lang="scss">
.flex-container {
	display: block;
	@media (min-width: map-get($media-queries-limit, 'mobile')) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
}
.flex-col {
	@media (min-width: map-get($media-queries-limit, 'mobile')) {
		width: calc(50% - #{$gap});
	}
}
.lista-titulo {
	border-bottom: 1px solid #000;
	font-size: map-get($fuente, "size-alto");
	padding: $gap*.5 0;
	margin: 0;
}
.lista-elementos {
	color: map-get($color, "texto");
	.enlace-investigadorxs {
		background: map-get($color-link, "fondo");
		color: map-get($color-link, "texto");
		&:hover{
			background: map-get($color-link, "hover-fondo");
			color: map-get($color-link, "hover-texto");
			.foto {
				margin-left: 12px;
				margin-right: 12px;
			}
		}
	}
	.elemento {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid rgba(0,0,0,.2);
		padding: $gap*.25 0;
		margin: 0;
		.foto {
			width: 72px;
			height: 72px;
			object-fit: cover;
			margin-right: 24px;
			transition: margin .2s ease-in-out;
			&.foto-redondeada {
				border-radius: 50%;
			}
		}
		.nombre {
			font-size: map-get($fuente, "size-primario");
			flex: 1;
			line-height: 1.1em;
		}
		.info-invest {
			flex: 1;
			margin-left: $gap*.25;
			.nombre {
				font-size: map-get($fuente, "size-alto");
				line-height: 1.1em;
				margin: 0;
			}
			.cargo {
				font-size: map-get($fuente, "size-secundario");
				line-height: 1.1em;
				margin: 8px 0;
			}
			.institucion {
				font-size: map-get($fuente, "size-secundario");
				line-height: 1.1em;
				margin: 0;
			}
		}
	}
}
</style>
